import { getStatusMeta, STATUS_REGISTRY } from '@/config/statuses.config';
import { useI18n } from '@/i18n';

/**
 * The ONLY component allowed to render a status pill. Every module —
 * Creators, Partnerships, Contracts, Connectors, Approvals — renders its
 * status through this one component instead of reimplementing colored
 * spans. Changing the visual language of "warning" happens here once.
 */
export function StatusBadge({ entity, statusKey }: { entity: keyof typeof STATUS_REGISTRY; statusKey: string }) {
  const { t } = useI18n();
  const meta = getStatusMeta(entity, statusKey);
  return <span className={`badge ${meta.tone}`}>{t(meta.labelKey)}</span>;
}
